<template>

<com-item name="game.context" :size="size" :loading="loading" :is-empty="!active" :any-height="true" :no-border="true" :no-hover="true" :is-container="true">

	<template v-slot:stats>

		<div class="context" v-if="active">

			<div class="context-avatar-wrapper" v-tooltip="avatarTooltip">
				<core-avatar type="context" class="context-avatar" />
			</div>

			<div class="context-quad is-collection">

				<div class="context-quad-icon"><i class="fa fa-box" /></div>

				<div class="context-quad-title" v-if="data.collection.active && data.collection.own">Own</div>
				<div class="context-quad-title" v-else-if="data.collection.active && data.collection.prevowned">Previously Owned</div>
				<div class="context-quad-title is-empty" v-else>Not in Collection</div>

				<div class="context-quad-details" v-if="data.collection.active">

					<div class="context-quad-detail" v-if="data.collection.prevowned && !data.collection.own && data.collection.dateRemoved">Removed {{ data.collection.dateRemoved | formatDate($util.date.format('Do', 'MMM', 'YYYY')) }}</div>
					<div class="context-quad-detail" v-else-if="data.collection.dateOwned">Added {{ data.collection.dateOwned | formatDate($util.date.format('Do', 'MMM', 'YYYY')) }}</div>

				</div>

				<div class="context-quad-details" v-if="!data.collection.active"></div>

			</div>

			<div class="context-quad is-rating">

				<div class="context-quad-icon"><i class="fa fa-star" /></div>

				<div class="context-quad-title" v-if="data.rating.active">Rated {{ data.rating.value }}</div>
				<div class="context-quad-title is-empty" v-else>Not Rated</div>

				<div class="context-quad-details" v-if="data.rating.active">

					<div class="context-quad-detail" v-if="data.rating.date">{{ data.rating.date | formatDate($util.date.format('Do', 'MMM', 'YYYY')) }}</div>

				</div>

				<div class="context-quad-details" v-if="!data.rating.active"></div>

			</div>

			<div class="context-quad is-plays">

				<div class="context-quad-icon"><i class="fa fa-dice" /></div>

				<div class="context-quad-title" v-if="data.plays.active">{{ data.plays.total }} Play{{ data.plays.total === 1 ? '' : 's' }}</div>
				<div class="context-quad-title is-empty" v-else>Not Played</div>

				<div class="context-quad-details" v-if="data.plays.active">

					<div class="context-quad-detail" v-if="data.plays.lastPlay">Last played {{ formatAgo(data.plays.lastPlay) }}</div>

				</div>

				<div class="context-quad-details" v-if="!data.plays.active"></div>

			</div>

			<div class="context-quad is-wishlist">

				<div class="context-quad-icon"><i class="fa fa-heart" /></div>

				<div class="context-quad-title" v-if="data.wishlist.active && data.wishlist.current">Wishlisted</div>
				<div class="context-quad-title" v-else-if="data.wishlist.active">Was Wishlisted</div>
				<div class="context-quad-title is-empty" v-else>Not Wishlisted</div>

				<div class="context-quad-details" v-if="data.wishlist.active && data.wishlist.current">

					<div class="context-quad-detail" v-if="data.wishlist.dateAdded">Since {{ data.wishlist.dateAdded | formatDate($util.date.format('Do', 'MMM', 'YYYY')) }}</div>

				</div>

				<div class="context-quad-details" v-else-if="data.wishlist.active && !data.wishlist.current">

					<div class="context-quad-detail" v-if="data.wishlist.dateAdded && data.wishlist.dateRemoved">{{ data.wishlist.dateAdded | formatDate($util.date.format('MMM', 'YYYY')) }} — {{ data.wishlist.dateRemoved | formatDate($util.date.format('MMM', 'YYYY')) }}</div>
					<div class="context-quad-detail" v-else-if="data.wishlist.dateRemoved">Removed {{ data.wishlist.dateRemoved | formatDate($util.date.format('Do', 'MMM', 'YYYY')) }}</div>

				</div>

				<div class="context-quad-details" v-if="!data.wishlist.active"></div>

			</div>

		</div>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	computed: {

		loading: function() { return this.fetching === 'all' },

		data: function() { return this.$store.getters['page/insights/game/context'] },

		active: function() { return this.data && !this.loading && (this.data.collection || this.data.rating || this.data.plays || this.data.wishlist) },

		game: function() { return this.$store.getters['page/insights/game/game'] },

		avatarTooltip: function() {
			var prefix = this.your.charAt(0).toUpperCase() + this.your.slice(1)
			return prefix + ' relationship with ' + ((this.game && this.game.name) ? this.game.name : 'this game')
		}

	},

	methods: {

		formatDays: function(days) {

			if (days < 30) return days + ' day' + (days === 1 ? '' : 's')
			if (days < 365) {
				var m = Math.round(days / 30)
				return m + ' month' + (m === 1 ? '' : 's')
			}
			var years = Math.floor(days / 365)
			var months = Math.round((days % 365) / 30)
			if (months > 0) return years + 'y ' + months + 'mo'
			return years + ' year' + (years === 1 ? '' : 's')

		},

		formatAgo: function(timestamp) {

			var now = Math.floor(Date.now() / 1000)
			var days = Math.max(1, Math.floor((now - timestamp) / 86400))
			return this.formatDays(days) + ' ago'

		}

	}

}

</script>

<style scoped>

.context {
	position: relative;
	width: 100%;
	height: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: 1fr 1fr;
	gap: 6px;
}

.context-avatar-wrapper {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 64px;
	height: 64px;
	z-index: 1;
	cursor: default;
	transition: transform 100ms ease;
}

.context-avatar-wrapper:hover {
	transform: translate(-50%, -50%) scale(1.05);
}

.context-avatar-wrapper >>> .avatar {
	width: 64px;
	height: 64px;
	background-position: 50% 50%;
	background-size: cover;
	border: 6px solid #fff;
	border-radius: 50%;
}

.context-quad {
	border-radius: 4px;
	padding: 10px 16px 14px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	gap: 0;
}

.context-quad.is-collection { background-color: #4881bb; }
.context-quad.is-rating { background-color: #f5a623; }
.context-quad.is-plays { background-color: #2FC482; }
.context-quad.is-wishlist { background-color: #e85d75; }

.context-quad-icon {
	font-size: 24px;
	color: #fff;
	height: 40px;
	line-height: 40px;
	margin-bottom: 4px;
}

.context-quad-title {
	font-size: 14px;
	font-weight: 700;
	color: #fff;
	line-height: 18px;
	margin-bottom: 4px;
}

.context-quad-title.is-empty {
	color: rgba(255, 255, 255, 0.4);
}

.context-quad-details {
	height: 36px;
	display: flex;
	flex-direction: column;
	align-content: flex-start;
}

.context-quad-detail {
	font-size: 14px;
	font-weight: 500;
	color: rgba(255, 255, 255, 0.75);
	line-height: 18px;
}

</style>
